export const renderCurrentDate = (objToday, obj = false) => {
  const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayOfWeek = weekday[objToday.getDay()],
    domEnder = (function () {
      var a = objToday;
      if (/1/.test(parseInt((a + '').charAt(0)))) return 'th';
      a = parseInt((a + '').charAt(1));
      return 1 == a ? 'st' : 2 == a ? 'nd' : 3 == a ? 'rd' : 'th';
    })(),
    dayOfMonth = '' + (objToday.getDate() < 10) ? '' + objToday.getDate() + domEnder : objToday.getDate() + domEnder,
    months = new Array(
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ),
    curMonth = months[objToday.getMonth()];
  return !obj ? `${dayOfWeek}, ${curMonth} ${dayOfMonth}` : { dayOfWeek, dayOfMonth, curMonth };
};

export const renderTime = (date) =>
  new Intl.DateTimeFormat('default', {
    hour12: true,
    hour: 'numeric',
    minute: '2-digit',
  }).format(typeof date == 'string' ? new Date(date) : date);

// enter string or date object return array of date objects
const dayRangeGenerate = (day, interval) => {
  const dayOfRange = new Date(day);
  const currentDate = new Date();
  let range = [];
  for (let i = 0; i <= 23; i++) {
    for (let b = 0; b < 59; b += interval) {
      const date = new Date(day);
      date.setHours(i);
      date.setMinutes(b);
      date.setSeconds(0);
      date.setMilliseconds(0);
      range.push(date);
    }
  }

  if (dayOfRange.toDateString() === currentDate.toDateString()) {
    range = range.filter((item) => item > currentDate);
  }
  return range;
};

// enter range array (with string or obkect dates) and string or object date, return bool
export const rangeIncludDate = (date, range) => {
  const rangeInstance = range.map((item) => ({
    start: new Date(item.startTime),
    end: new Date(item.endTime),
  }));
  const dateInstance = new Date(date);

  return rangeInstance.some((item) => item.start <= dateInstance && dateInstance < item.end);
};

export const funcStarnTime = (day, existRange, interval = 15) => {
  let range = dayRangeGenerate(day, interval);
  range.pop(); // slice 23.45;
  range = range.filter((item) => !rangeIncludDate(item, existRange));
  return range;
};
